import React from "react";
import { Link } from "react-router-dom"; // React Router v6
import { Bus, Facebook, Twitter, Instagram, Mail, Phone, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import coLogo from "../images/logo.png";

export function Footer() {
    const { t, i18n } = useTranslation();
    const language = i18n.language;
    const isRTL = language === "ar" || language === "he";
    const year = new Date().getFullYear();

    return (
        <footer className="bg-slate-900 text-slate-100 pt-16 pb-8 border-t-4 border-accent" dir={t('dir')}>
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
                    {/* Brand Column */}
                    <div className="space-y-6">
                        <div className="flex items-center gap-3">
                            <div className="w-18 h-16 bg-accent rounded-lg flex items-center justify-center text-slate-900 shadow-lg shadow-accent/20">
                                {/* <Bus className="w-7 h-7" /> */}
                                <img src={coLogo} alt={t("coName")} className="h-10" />
                            </div>
                            <div className="flex flex-col">
                                <span className="font-bold text-2xl leading-none text-white uppercase tracking-tight">{t('coName')}</span>
                                {/* <span className="text-xs font-medium text-accent tracking-widest uppercase">{t('coSubName')}</span> */}
                            </div>
                        </div>
                        <p className="text-slate-400 leading-relaxed">
                            {t('safeTransport')}
                        </p>
                        <div className="flex gap-4">
                            <a href="https://www.facebook.com/abdo.transportation.co/" target="_blank"
                                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent hover:text-slate-900 transition-all duration-300">
                                <Facebook className="w-5 h-5" />
                            </a>
                            {/* <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent hover:text-slate-900 transition-all duration-300">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent hover:text-slate-900 transition-all duration-300">
                <Instagram className="w-5 h-5" />
              </a> */}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-bold mb-6 text-white border-b border-white/10 pb-2 inline-block">{t('quickLinks')}</h3>
                        <ul className="space-y-3">
                            <li><Link to="/" className="text-slate-400 hover:text-accent transition-colors">{t('home')}</Link></li>
                            <li><Link to="/about" className="text-slate-400 hover:text-accent transition-colors">{t('aboutUs')}</Link></li>
                            <li><Link to="/services" className="text-slate-400 hover:text-accent transition-colors">{t('services')}</Link></li>
                            <li><Link to="/Fleet" className="text-slate-400 hover:text-accent transition-colors">{t('fleet')}</Link></li>
                            <li><Link to="/jobs" className="text-slate-400 hover:text-accent transition-colors">{t('applyJob')}</Link></li>
                            <li><Link to="/contact" className="text-slate-400 hover:text-accent transition-colors">{t('contactUs')}</Link></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-bold mb-6 text-white border-b border-white/10 pb-2 inline-block">{t('contactUs')}</h3>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3">
                                <MapPin className="w-5 h-5 text-accent shrink-0 mt-1" />
                                <span className="text-slate-400">{t('coAddress')}</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone className="w-5 h-5 text-accent shrink-0" />
                                <span className="text-slate-400" style={{ direction: 'ltr' }}>+972 59-984-4222</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone className="w-5 h-5 text-accent shrink-0" />
                                <span className="text-slate-400" style={{ direction: 'ltr' }}>+972 50-544-5766</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail className="w-5 h-5 text-accent shrink-0" />
                                <span className="text-slate-400">info@abdobus.com</span>
                            </li>
                            {/* <li className="flex items-center gap-3">
                                <Mail className="w-5 h-5 text-accent shrink-0" />
                                <span className="text-slate-400">info@abdobus.com</span>
                            </li> */}
                        </ul>
                    </div>

                    {/* Newsletter / Map Placeholder */}
                    {/* <div className="bg-white/5 rounded-2xl p-6 border border-white/10">
                        <h4 className="font-bold text-accent mb-2">{t.withYou}</h4>
                        <p className="text-sm text-slate-400 mb-4">Subscribe for updates on border status and schedules.</p>
                        <div className="flex gap-2">
                            <input
                                type="email"
                                placeholder={t.email}
                                className="bg-slate-900 border-none rounded px-3 py-2 text-sm w-full focus:ring-1 focus:ring-accent"
                            />
                            <button className="bg-accent text-slate-900 px-3 rounded font-bold hover:bg-white transition-colors">OK</button>
                        </div>
                    </div> */}
                </div>

                <div className="pt-8 border-t border-white/10 text-center text-slate-400 text-sm">
                    <p> {t('allRightsReserved')} &copy; {year} {t('appName')} </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;